export const BookmaniaFontFamily = 'Bookmania, serif';
export const StyreneAFontFamily = 'StyreneA, sans-serif';
